import { render, staticRenderFns } from "./JSONEditor.vue?vue&type=template&id=65054cf2&"
import script from "./JSONEditor.vue?vue&type=script&lang=js&"
export * from "./JSONEditor.vue?vue&type=script&lang=js&"
import style0 from "./JSONEditor.vue?vue&type=style&index=0&id=65054cf2&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports